import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionDatabaseComponent } from './question-database.component';


import { QuestionDetailsComponent } from './question-details/question-details.component';
import { QuestionListComponent } from './question-list/question-list.component';
import { AddQuestionComponent } from './add-question/add-question.component';
import { MediaImportComponent } from './media-import/media-import.component';
import { MachineTranslationComponent } from './machine-translation/machine-translation.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MultiSelectModule } from 'primeng/multiselect';
import { FileUploadModule } from 'primeng/fileupload';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { TabViewModule } from 'primeng/tabview';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { FasServiceTableComponent, FasServicesUploadComponent } from 'fas-services';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { TooltipModule } from 'primeng/tooltip';
import { SplitButtonModule } from 'primeng/splitbutton';

@NgModule({
  declarations: [
    QuestionDatabaseComponent,
    QuestionListComponent,
    QuestionDetailsComponent,
    AddQuestionComponent
  ],
  imports: [
    FasServiceTableComponent,
    FasServicesUploadComponent,
    MediaImportComponent,
    MachineTranslationComponent,
    BrowserAnimationsModule,
    ProgressSpinnerModule,
    ReactiveFormsModule,
    MultiSelectModule,
    FileUploadModule,
    DropdownModule,
    CheckboxModule,
    TabViewModule,
    DialogModule,
    CommonModule,
    FormsModule,
    TableModule,
    DynamicDialogModule,
    ButtonModule,
    InputTextModule,
    InputTextareaModule,
    InputNumberModule,
    TooltipModule,
    SplitButtonModule 
  ],
  exports: [QuestionDatabaseComponent],
  providers: [MessageService, ConfirmationService, DialogService],
})
export class QuestionDatabaseModule { }
